<template>
    <div class="common-title-box">
        <div class="flex-start">
            <div class="common-title">{{title}}</div>
            <slot></slot>
        </div>
        <div v-if="showMore">
            <a class="more" @click="goMore" href="javascript:;">更多 ></a>
        </div>
    </div>
</template>
<script setup>
import { toRefs } from 'vue'
const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    showMore: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['goMore'])

function goMore() {
    emit('goMore');
}   
</script>

<style lang="scss" scoped>
.common-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 40px;
    .common-title {
        font-size: 20px;
        font-weight: bold;
        color: #222222;
        line-height: 26px;
    }
    .more {
        font-size: 14px;
        line-height: 14px;
        margin-top: 10px;
        display: block;
        user-select: none;
        color: var(--srt-color-gray);
    }
}
</style>
